// extracted by mini-css-extract-plugin
export default {"mainContent":"Pagina3_mainContent__m4YDB","faixa":"Pagina3_faixa__EmaAx"};